export default class ActivateAccountCtrl {

    // @ngInject
    constructor(authService, responseHandler, $routeParams, $location) {
        this.authService = authService;
        this.responseHandler = responseHandler;
        this.$location = $location;

        this.userCredentials = {
            password1: undefined,
            password2: undefined,
            key: $routeParams.key
        };
    }

    submit() {
        let promise = this.authService.activate(this.userCredentials);
        // Execute responseHandler's other functionality.
        this.responseHandler(promise, 'activating your account')
            .then(() => this.goNext());
    }

    goNext() {
        this.$location.path('/activate/confirmation');
    }
}



// WEBPACK FOOTER //
// ./activate/activate/activate-ctrl.js